<script setup lang="ts">
import { computed, defineProps, defineEmits } from 'vue';
import FormatUtils from '@/utils/format_utils';

const props = defineProps<{
  title: string,
  lastUpdate: Date | null | undefined,
  state?: 'error' | 'default',
  supportingText?: string,
}>();

defineEmits<{
  (e: 'change-page'): void,
}>();

const state = computed(() => props.state ?? 'default');

function getState() {
  return `${state.value}`;
}

</script>

<template>
  <div class="staff-container" :style="{
    border: `1px solid var(--components-input-${getState()}-border-color, #CDC8D7)`,
    color: `var(--components-input-${getState()}-text-color, #CDC8D7)`,
    backgroundColor: `var(--components-input-${getState()}-background-color, rgba(0, 0, 0, 0.00))`,
    fontWeight: `var(--components-input-${getState()}-font-weight, 800)`,
    borderTop: `1px solid var(--components-input-${getState()}-border-color, #CDC8D7)`,
  }" @click="() => $emit('change-page')">
    <div class="text-container">
      <p class="first-text">{{ props.title }}</p>
      <p v-if="lastUpdate" class="second-text">
        <span>Última Atualização</span>
        {{ FormatUtils.datetime(props.lastUpdate) }}
      </p>
      <p v-else class="second-text">
        <span>O plano não possui colaboradores</span>
      </p>
    </div>
    <i class="bi bi-arrow-right"></i>
  </div>
  <p class="supporting-text" :style="`color: var(--components-input-${getState()}-supporting-text-color)`"
    v-if="props.supportingText && getState() === 'error'">
    {{ props.supportingText }}
  </p>
</template>

<style scoped>

.staff-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 24px 32px;
  align-items: center;
  cursor: pointer;
  border-radius: 7px;
  border: 1px solid #F2F1F3;
  background: #FFF;
  justify-content: space-between;
}

.text-container {
  flex-direction: column;
  align-items: flex-start;
  padding-right: 32px;
}

.second-text {
  color: var(--semantic-color-gray-subtle, var(--semantic-color-gray-subtle, #6E6979));
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 140%;
}

.first-text {
  color: var(--option-color-gray-800, #434049);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}

.supporting-text {
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 300;
}

@media screen and (max-width: 500px) {
  .text-container {
    padding-right: 12px;
  }
}

</style>